<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ "REPLENISHMENT_SELECTION" | translate }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
    >
  </button>
</div>
<div class="modal-body">
  @if (loaded) {
    <table class="table">
      <thead>
        <tr class="fw-bold">
          <td>{{ "ARTICLE_NO" | translate }}</td>
          <td>{{ "BATTERY" | translate }}</td>
          <td>{{ "DESCRIPTION" | translate }}</td>
          <td>{{ "STATUS" | translate }}</td>
          <td style="max-width: 50px">{{ "CURRENT_STOCK" | translate }}</td>
          <td style="min-width: 120px">{{ "CURRENT_MIN_STOCK" | translate }}</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        @for (article of articles; track article; let i = $index) {
          @if (article.min_stock > 0) {
            <tr>
              <td class="py-1">
                <span [articleQuickView]="article.article_code">{{
                  article.article_code
                }}</span>
              </td>
              <td class="py-1">
                @if (article.battery_article_code) {
                  <span
                    class="battery-indication"
                    [articleQuickView]="article.battery_article_code"
                    >
                    {{ article.battery_article_code }}
                  </span>
                }
              </td>
              <td class="py-1">{{ article.article_description }}</td>
              <td class="py-1">
                <app-stock-status [article]="article"></app-stock-status>
              </td>
              <td class="py-1">{{ article.stock }}</td>
              <td class="py-1" style="max-width: 50px">{{ article.min_stock }}</td>
              <td class="py-1 d-flex justify-content-end" style="min-width: 120px">
                @if (!readonly) {
                  <button
                    class="text-danger me-2 btn btn-default"
                    (click)="remove(article, i)"
                    >
                    {{ "DELETE" | translate }}
                  </button>
                }
                @if (!readonly) {
                  <button
                    class="btn btn-sm btn-primary"
                    (click)="edit(article.article_code)"
                    >
                    {{ "EDIT" | translate }}
                  </button>
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  }
  @if (!loaded) {
    <div
      class="spinner-grow text-primary spinner-loader"
      role="status"
      >
      <span class="visually-hidden">{{ "LOADING" | translate }}...</span>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-dark" (click)="modal.dismiss('Close')">
    {{ "CLOSE" | translate }}
  </button>
</div>
